bovoApp.controller('StockController', ['$scope', 'Stock', '$location','$routeParams','$filter',
  function ($scope, Stock, $location, $routeParams, $filter) {
    $scope.deleted = [];
		$scope.filterData = {
      workers: [],
      page: 1
    }
    
    $scope.all = function (type) {
      if(typeof type !== 'undefined' && type == 'clear') {
				$scope.filterData = {
					term: '',
					workers: [],
					workSteps: [],
					created_at : { 
						startDate: null, 
						endDate: null 
					},
					scheduled_time : { 
						startDate: null, 
						endDate: null 
					}
				}
      }
      
      Stock.all($scope.filterData).success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.getPage = function(page) {
			$scope.filterData.page = page;
			$scope.all();
    }
    
    $scope.sort = function(field,sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.all();
    }
    
    $scope.clearFilter = function(page) {
			$scope.filterData = {
				workers: [],
				workSteps: [],
				created_at : { 
					startDate: null, 
					endDate: null 
				},
				scheduled_time : { 
					startDate: null, 
					endDate: null
				}
			}
			$scope.filterProp = [];
			$scope.all('clear');
		}


    $scope.get = function () {
      Stock.get($routeParams.id).success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }
    
    $scope.new = function () {
      Stock.new().success(function(data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.delete = function (type) {
			if(type == 'set') {
        $('#delete').modal('show');
      } else if(type == 'delete') {
				Stock.delete($scope.deleted).success(function(data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.stocks.indexOf($filter('filter')($scope.data.stocks, {id: $scope.deleted[i] })[0]);
            if (index > -1)
              $scope.data.stocks.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
				}).error(function(data) {
          Messenger().post({message: data.message,type: "error"});
				});
			} 
		}

		$scope.save = function () {
			Stock.save($scope.stock).success(function(data, status, headers, config) {
				$scope.data = data;
        Messenger().post(data.message);
        $location.path('stok/urunler');
			}).error(function(data) {
        Messenger().post({message: data.message,type: "error"});
      });
		}

		$scope.update = function () {
			Stock.update($scope.data.stock).success(function(data, status, headers, config) {
				$scope.data = data;
        Messenger().post(data.message);
        $location.path('stok/urunler');
			}).error(function(data) {
        Messenger().post({message: data.message,type: "error"});
      });
		}

    $scope.goTo = function(id) {
      $location.path('stok/urun/' + id);
    }

    $scope.customerSelect = function(selected,type) {
      if(typeof type === 'undefined') {
          if(typeof selected !== 'undefined') {
              var customer = selected.originalObject;
          }else {
              var customer = [];
          }
      }else {
          var customer = selected;
      }
      if(typeof customer !== 'undefined' && typeof $scope.stock !== 'undefined') {
        $scope.stock.company_customer_id = customer.id;
        $scope.stock.company_customer = customer.customer_name;
      }
      if(typeof customer !== 'undefined' && typeof $scope.data.stock !== 'undefined') {
        $scope.data.stock.company_customer_id = customer.id;
        $scope.data.stock.company_customer = customer.customer_name;
      }

  }

  $scope.toggleSelection = function toggleSelection(id) {
    var idx = $scope.deleted.indexOf(id);
    if (idx > -1) {
      $scope.deleted.splice(idx, 1);
    }
    else {
      $scope.deleted.push(id);
    }
  };

  }
]);
